import styled from 'styled-components';
import { TooltipAdvanced } from '../../../core/Tooltip';
// Capa que contiene el ToolTip
export const TooltipContent = styled.div`
  display: inline-block;
  position: relative;
  /* Estilos para que aparezca el tooltip */
  &:hover span {
    opacity: 1;
    max-height: 92px;
    visibility: visible;
  }
`;
// ToolTip
export const StyledTooltip = styled(TooltipAdvanced)`
  font-family: ${props => props.theme.fonts.regular};
  font-size: ${props => props.theme.fontSize.small};
  letter-spacing: -0.2px;
  line-height: 15px;
  margin-left: -186px;
  padding: 16px 20px;
  width: 400px;
`;
// Tooltip > texto: "Usuarios"
export const TooltipUser = styled.p`
  display: inline;
  font-family: ${props => props.theme.fonts.semiBold};
  font-size: ${props => props.theme.fontSize.small};
  padding-right: 5px;
`;
